import React, { Component, Fragment } from "react";

import positions from "../../db/positions.json";

import Header from "../Header";
import PositionBox from "../PositionBox";
import AboutUs from "../AboutUs";

class CareersIndex extends Component {
  filterPositions(filter) {
    let p = positions;
    if (filter) {
      p = positions.filter(({ title }) => {
        return (
          title === "Full stack developer" ||
          title === "Product Manager" ||
          title === "Customer Success Associate" ||
          title === "Inside Sales Associate" ||
          title === "Stores Onboarding Associate" ||
          title === "Back-end developer"
        );
      });
    }
    return p;
  }

  renderPositions() {
    const positionsToShow = this.filterPositions(true);
    return positionsToShow.map(position => (
      <PositionBox key={position.title} position={position} />
    ));
  }

  render() {
    const { marginTopStyle, headingStyle } = styles;
    if (positions.length === 0) {
      return (
        <Fragment>
          <Header />
          <hr />
          <h3>
            Sorry, we are out of vacancies! <br /> :_(
          </h3>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <Header />
        <br />
        <div className="row" style={marginTopStyle}>
          <div className="col-12" style={{ textAlign: "center" }}>
            <h2 style={headingStyle}>Open positions</h2>
          </div>
          {this.renderPositions()}
        </div>
        <div style={{ marginTop: "150px" }}>
          <AboutUs />
        </div>
        <div style={footerContainer}>
          <div>
            <span style={{ fontSize: ".8rem" }}>
              <b>ARE YOU READY TO BE ON OUR TEAM?</b>
            </span>
          </div>
          <br />
          <div>
            <button onClick={() => window.scrollTo(0, 0)} style={buttonStyle}>
              Go back to open positions
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

const footerContainer = {
  marginTop: "100px",
  marginBottom: "70px",
  display: "flex",
  flexFlow: "column",
  alignItems: "center"
};
const buttonStyle = {
  background: "#FFFFFF",
  border: "1px solid #1578D7",
  boxSizing: "border-box",
  borderRadius: "8px",
  padding: "10px 30px 10px 30px",
  fontSize: "1.1rem",
  color: "#1578D7",
  cursor: "pointer"
};
const styles = {
  imgStyle: {
    width: "75%",
    maxWidth: "250px"
  },
  logoStyle: {
    width: "30%",
    minWidth: "150px",
    marginBottom: "100px"
  },
  titleStyle: {
    color: "#749b08",
    fontSize: "1.8em"
  },
  headingStyle: {
    color: "#749b08",
    marginBottom: "20px"
  },
  marginTopStyle: {
    marginTop: "50px"
  },
  textStyle: {
    textAlign: "justify",
    fontSize: "1.2em"
  }
};

export default CareersIndex;
